import { render, staticRenderFns } from "./AdminGestoresEscolares.vue?vue&type=template&id=0498bfa6&scoped=true&"
import script from "./AdminGestoresEscolares.vue?vue&type=script&lang=js&"
export * from "./AdminGestoresEscolares.vue?vue&type=script&lang=js&"
import style0 from "./AdminGestoresEscolares.vue?vue&type=style&index=0&id=0498bfa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498bfa6",
  null
  
)

export default component.exports